import { gql } from '@apollo/client';
import client from 'apollo/client';

/**
 * Sube una imagen embebida del editor (Noticias / T&C) y devuelve su URL pública.
 * Usa el Upload link de Apollo (apollo-upload-client) ya configurado.
 *
 * @param  {File} image
 * @return {Promise}
 */
const uploadImage = (image) =>
  client.mutate({
    mutation: gql`
      mutation uploadContentImage($image: Upload!) {
        uploadContentImage(image: $image) {
          url
        }
      }
    `,
    variables: { image }
  });

/**
 * Sube multimedia del editor (imagen, video o audio) y devuelve su URL pública en S3.
 * @param  {File} file
 * @return {Promise}
 */
const uploadMedia = (file) =>
  client.mutate({
    mutation: gql`
      mutation uploadContentMedia($file: Upload!) {
        uploadContentMedia(file: $file) {
          url
        }
      }
    `,
    variables: { file }
  });

/**
 * Sube multimedia embebida en la descripción del foro de OTRIX Play (imagen, video o audio).
 * Mismo pipeline endurecido que uploadMedia, pero autorizado para clientes de Play (los admins
 * de Noticias no son quienes publican en el foro).
 * @param  {File} file
 * @return {Promise}
 */
const uploadPlayMedia = (file) =>
  client.mutate({
    mutation: gql`
      mutation uploadPlayMedia($file: Upload!) {
        uploadPlayMedia(file: $file) {
          url
        }
      }
    `,
    variables: { file }
  });

export default { uploadImage, uploadMedia, uploadPlayMedia };
